import simulationNotFound from '@/assets/simulation-not-found.svg';
import { PageWrapper } from '@/components/page-wrapper/page-wrapper';
import { ResponsiveEmptyStateIllustration } from '@/components/responsive-empty-state-illustration';
import { ROUTES } from '@/routes';
import { Button } from '@lego/connect-components-react';
import type { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

// Shown when the simulation doesn't exist or the user has no access to it
export const SimulationNotFoundPage = (): ReactElement => {
  const navigate = useNavigate();

  return (
    <PageWrapper headerProps={{ title: 'Simulation not Found' }} layout="fill">
      <div
        style={{
          alignItems: 'center',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
          minHeight: '240px',
          padding: '16px',
          width: '100%',
        }}
      >
        <ResponsiveEmptyStateIllustration
          src={simulationNotFound}
          alt="Simulation not found"
          maxWidth={1502}
          height="auto"
          maxHeight="calc(100dvh - 200px)"
        />
        <Button
          onClick={() => navigate(ROUTES.SimulationList.path)}
          aria-label="Back to simulations"
        >
          Back to simulations
        </Button>
      </div>
    </PageWrapper>
  );
};
